export default "__VITE_ASSET__DXdNa7TV__"